/**
 * Currency conversion utilities
 * Exchange rate from API is FROM SAR TO the target currency
 */

export interface CurrencyInfo {
  exchange_rate: number;
  currency_code: string;
  is_base_currency: boolean;
}

/**
 * Convert price FROM SAR TO display currency
 * @param priceInSAR - Price in SAR (base currency)
 * @param exchangeRate - Exchange rate FROM SAR TO target currency
 * @returns Price in target currency
 */
export const convertFromSAR = (priceInSAR: number, exchangeRate: number): number => {
  if (!exchangeRate || exchangeRate === 0) return priceInSAR;
  return priceInSAR * exchangeRate;
};

/**
 * Convert price FROM display currency BACK TO SAR
 * @param priceInDisplayCurrency - Price in display currency
 * @param exchangeRate - Exchange rate FROM SAR TO target currency
 * @returns Price in SAR
 */
export const convertToSAR = (priceInDisplayCurrency: number, exchangeRate: number): number => {
  if (!exchangeRate || exchangeRate === 0) return priceInDisplayCurrency;
  return priceInDisplayCurrency / exchangeRate;
};

/**
 * Format price with currency code
 */
export const formatPrice = (price: number, currencyCode: string): string => {
  return `${price.toFixed(2)} ${currencyCode}`;
};












